export default {
  /**
   * 指定した年月の日リストを取得する
   * @returns
   */
  getDays: function ({ year, month }) {
    let days = [];
    if (year === '' || month === '') return days;

    let maxDay = 31;
    switch (parseInt(month)) {
      case (4, 6, 9, 11): // 4月、6月、9月、11月
        maxDay = 30;
        break;
      case 2: // 2月
        // うるう年なら２月２９日はgetMonth()で1（2月）を返すためtrue、それ以外（3月を返す）ならfalse
        maxDay = new Date(year + '/02/29').getMonth() === 1 ? 29 : 28;
        break;
      default: // 1月、3月、5月、7月、8月、10月、12月
        maxDay = 31;
    }

    for (let i = 1; i <= maxDay; i++) {
      days.push(('00' + i).slice(-2));
    }
    return days;
  },
  /**
   * 月リストを取得する
   * @returns
   */
  getMonths: function () {
    return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
  },
  /**
   * 1900年以降の年リストを取得する
   * @returns
   */
  getYears: function () {
    //return ['2021', '2020', '2019'];
    const thisYear = new Date().getFullYear();
    let years = [];
    for (let i = thisYear + 1; 1900 < i; i--) {
      years.push(i);
    }
    return years;
  },
  /**
   * 都道府県リスト
   */
  prefectures: [
    '北海道',
    '青森県',
    '岩手県',
    '宮城県',
    '秋田県',
    '山形県',
    '福島県',
    '茨城県',
    '栃木県',
    '群馬県',
    '埼玉県',
    '千葉県',
    '東京都',
    '神奈川県',
    '新潟県',
    '富山県',
    '石川県',
    '福井県',
    '山梨県',
    '長野県',
    '岐阜県',
    '静岡県',
    '愛知県',
    '三重県',
    '滋賀県',
    '京都府',
    '大阪府',
    '兵庫県',
    '奈良県',
    '和歌山県',
    '鳥取県',
    '島根県',
    '岡山県',
    '広島県',
    '山口県',
    '徳島県',
    '香川県',
    '愛媛県',
    '高知県',
    '福岡県',
    '佐賀県',
    '長崎県',
    '熊本県',
    '大分県',
    '宮崎県',
    '鹿児島県',
    '沖縄県',
    '海外',
  ],
};
